class HeroSplitSlider {
  constructor(el) {
    this.el = el;
    this.slides = [...el.querySelectorAll('.hero-split__slide')];
    this.dots = [...el.querySelectorAll('.hero-split__dot')];
    this.current = 0;
    this.total = this.slides.length;
    this.autoPlay = el.dataset.autoplay === 'true';
    this.speed = parseInt(el.dataset.speed || 5) * 1000;

    el.querySelector('.hero-split__nav--prev')?.addEventListener('click', () => this.prev());
    el.querySelector('.hero-split__nav--next')?.addEventListener('click', () => this.next());
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

    if (this.autoPlay && this.total > 1) this.startAutoPlay();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');
    this.current = ((index % this.total) + this.total) % this.total;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  startAutoPlay() {
    const tick = () => this.next();
    this.timer = setInterval(tick, this.speed);
    this.el.addEventListener('mouseenter', () => clearInterval(this.timer));
    this.el.addEventListener('mouseleave', () => { this.timer = setInterval(tick, this.speed); });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-split[data-slider]').forEach(el => new HeroSplitSlider(el));
});
